window.cusVueFunc = {};